import React from 'react'
import clsx from 'clsx'
import { useTheme } from '@mui/material'

import OverflowTooltip from '@SonarCX/components/atoms/OverflowTooltip'

import { formatDateRelative } from '@SonarCX/utilities'
import { useAppDispatch } from '@SonarCX/hooks/redux'
import {
  changeMutateDashboardOnEdit,
  editReminder
} from '@SonarCX/slices/reminder'
import { AddErrorAlert } from '@SonarCX/slices/alert'

import useStyles from './styles'
import EventIconMap from '@SonarCX/pages/Dashboard/PlannerTab/components/EventIconMap'

type ReminderRowProps = {
  reminders: APIReminder[]
  apiReminders: APIReminder[]
}

const ReminderRow = ({ reminders, apiReminders }: ReminderRowProps) => {
  const classes = useStyles()
  const theme = useTheme()

  const dispatch = useAppDispatch()
  const handleClick = React.useCallback(
    async (reminder: APIReminder) => {
      const actualReminder = apiReminders.find(f => f.id === reminder.id)
      if (!actualReminder) {
        dispatch(AddErrorAlert({ err: { message: 'Reminder not found' } }))
        return
      }
      dispatch(changeMutateDashboardOnEdit(true))
      dispatch(editReminder(actualReminder))
    },
    [dispatch, apiReminders]
  )

  return [
    <div key='tasks-header' className={classes.headerContainer}>
      <div className={clsx(classes.grid, classes.itemHeader)}>
        <div>Title</div>

        <div>Reminder Date</div>

        <div>Description</div>

        <div></div>
      </div>

      <div className={classes.separator}>
        <div />
      </div>
    </div>,

    ...reminders.map((reminder, i) => (
      <div
        key={`${reminder.id}-${i}`}
        onClick={() => handleClick(reminder)}
        className={clsx(classes.grid, classes.itemRow)}
      >
        <div className={classes.titleCell}>
          <EventIconMap theme={theme} objectType={reminder.object_type} />
          {reminder.title}
        </div>

        <div>{formatDateRelative(reminder.stamp, true)}</div>

        <OverflowTooltip>{reminder.details}</OverflowTooltip>
      </div>
    ))
  ]
}

export default ReminderRow
